import React from "react";

interface YearPickerProps {
    value: number;
    onChange: (value: number) => void;
}

export const YearPicker: React.FC<YearPickerProps> = ({ value, onChange }) => {
    // Generate years from 1900 to current year + 10
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1950 + 11 }, (_, i) => currentYear - i);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedYear = parseInt(e.target.value, 10);
        if (!isNaN(selectedYear)) {
            onChange(selectedYear);
        }
    };

    return (
        <div className="flex flex-col items-center gap-1 w-full">
            <label className="font-semibold font-ppmori text-osBlack">select year</label>
            <select
                value={value || ''}
                onChange={handleChange}
                className={`h-[44px] w-[115px] px-4 rounded-[18px] border-1 border-osBlack font-semibold transition-all duration-200 text-lg
                    ${value ? 'text-osBlack' : 'text-gray-500'}
                    border-gray-300 hover:border-gray-400 focus:border-osHardBlack focus:outline-none
                    appearance-none cursor-pointer`}
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                    backgroundPosition: 'right 1rem center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '1.5em 1.5em'
                }}
            >
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
    );
};

